import React, { useState } from "react";
import LearningActiviesStyle from "./style";
import { Button, Col, Dropdown, Form, Input, Popover, Row, Table } from "antd";
import {
  SearchOutlined,
  DownloadOutlined,
  CloseOutlined,
  FilterOutlined,
} from "@ant-design/icons";
import COLORS from "../../../../common/Colors";
import styled from "styled-components";

const StyledTable = styled(Table)`
  padding-top: 20px;
  table {
    width: 100% !important;
  }
  .ant-table-content {
    overflow-x: auto;
    white-space: nowrap;
    border: 1px solid #00000024;
    border-radius: 10px;
  }
  .ant-table-cell {
    padding: 20px;
  }
  .normal-column {
    min-width: 300px;
    white-space: normal;
  }
  .ant-table-thead .ant-table-cell {
    font-weight: 600;
    font-size: 0.9rem;
    color: ${COLORS.SECONDARY_BLACK};
    white-space: nowrap;
  }
  .non-white {
    background: #f9f9f9;
  }
  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-cell-row-hover {
    background: #e3e8fc !important;
  }
`;

const StyledImg = styled.img`
  cursor: pointer;
`;

const LearningActivies = () => {
  const [tableViewData, setTableViewData] = useState();
  const [userRenderView, setUserRenderView] = useState("table-view");
  const [filterValue, setFilterValue] = useState("");

  const columns1 = [
    {
      title: "Learning activity",
      dataIndex: "learningActivity",
      key: "learningActivity",
      sorter: (a, b) => a.user - b.user,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
    },
    {
      title: "Course name",
      dataIndex: "courseName",
      key: "courseName",
    },
    {
      title: "Completed",
      dataIndex: "completed",
      key: "completed",
    },
    {
      title: "In progress",
      dataIndex: "inProgress",
      key: "inProgress",
    },
    {
      title: "Not passed",
      dataIndex: "notPassed",
      key: "notPassed",
    },
    {
      title: "Not attempted",
      dataIndex: "notAttempted",
      key: "notAttempted",
    },
    {
      title: "Average score",
      dataIndex: "averageScore",
      key: "averageScore",
    },
  ];

  const dataSource1 = [
    {
      key: 1,
      learningActivity: "Assignment unit",
      type: "Test",
      courseName: "Development",
      completed: "0",
      inProgress: "0",
      notPassed: "0",
      notAttempted: "0",
      averageScore: "0",
    },
  ];

  const onChangeSortedTable = (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  };

  const handleClickData = (data) => {
    setUserRenderView("view-table");
    setTableViewData(data);
  };

  const items = [
    {
      label: "Active",
      key: "active", // Adding a key for better item identification
    },
    {
      label: "InActive",
      key: "inactive",
    },
  ];

  const handleClickFilter = (data) => {
    setFilterValue(data.label);
  };

  return (
    <>
      <LearningActiviesStyle>
        <div className="user-title-container users-menu-filter-container">
          <h1 className="user-menu-title">Learning activities reports</h1>
        </div>

        <br></br>
        <Row className="users-menu-filter-container">
          <Col>
            <Form.Item name="search" className="search-input-field">
              <Input suffix={<SearchOutlined />} placeholder="Search" />
            </Form.Item>
          </Col>

          <Dropdown
            menu={{
              items,
              onClick: ({ key, domEvent }) => {
                // Find the clicked item based on the key
                const clickedItem = items.find((item) => item.key === key);
                handleClickFilter(clickedItem);
              },
            }}
            title="Status"
            trigger={["click"]}
          >
            <Popover placement="top" content="Filters">
              <div className="filter_icon_box"><FilterOutlined /></div>
            </Popover>
          </Dropdown>

          {filterValue && (
            <Button className="active_filter_button">
              <CloseOutlined onClick={() => setFilterValue("")} />
              {filterValue} 
            </Button>
          )}
        </Row>

        <StyledTable
          dataSource={dataSource1}
          columns={columns1}
          rowClassName={(record, index) => (index % 2 === 0 ? "" : "non-white")}
          rowKey="checkin_id"
          id="Table"
          onChange={onChangeSortedTable}
          showSorterTooltip={{
            target: "sorter-icon",
          }}
          onRow={(record, rowIndex) => {
            return {
              onClick: () => {
                handleClickData(record);
              },
            };
          }}
        />

        <div className="download_csv_con">
          <Popover placement="top" content="Save as CSV">
            <DownloadOutlined />
          </Popover>
        </div>
      </LearningActiviesStyle>
    </>
  );
};

export default LearningActivies;
